<template>
  <div class="single-product">
    <v-container>
      <v-row>
        <v-col cols="3">
          <div class="sub-categories">
            <div class="title-sub-categories">
              <span style="color: white">{{ oracle.translate('دسته بندی') }}</span>
            </div>
            <ul v-if="!IsTrue" :style="isEN? 'padding-left: 20px !important;' : 'padding-right: 20px !important;'">
              <li
                  class="item-sub-categories"
                  v-for="(itemcat, index) in AllCat"
                  :key="index">
                <span class="font-weight-bold" style="font-size: 15px !important;">{{ oracle.category_name(itemcat) }}</span>
                <ul>
                  <li
                      v-for="(item, index) in itemcat.subcat"
                      :key="index"
                      v-ripple role="button"
                      @click="getcategory(item.category_id, oracle.category_name(item))">
                    <a class="mrx-1">{{ oracle.category_name(item) }}
                      <i :class="isEN ? 'mdi-chevron-right' : 'mdi-chevron-left'" class="mdi"
                         style="color: #7dc353"></i></a>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </v-col>
        <v-col cols="9">
          <div class="inner-product">
            <div class="inner-page-product">
              <div class="head-page-product">
                <div class="btn-likes" v-ripple role="button" @click="SetFAv()">
                  <v-icon v-if="Isfav">favorite</v-icon>
                  <v-icon v-if="!Isfav">favorite_border</v-icon>
                </div>
                <div class="img-head-page-product">
                  <img alt="" :src="AllOneP.product_icon"/>
                </div>
                <div class="name-product">
                  <span class="multi-line font-weight-bold">{{ oracle.product_title(AllOneP) }}</span>
                </div>
              </div>
              <div class="text-page-product">
                <span style="color: #7dc353; font-size: 20px"
                      class="font-weight-bold">{{
                    oracle.format(AllOneP.product_sell_price)
                  }} {{ oracle.translate('تومان') }}</span>

                <a href="products">
                  <span class="item-category">{{ AllOneP.product_category }}</span>
                </a>
              </div>
              <div class="add-to-lists"><p style="white-space: pre-wrap; font-size: 14px">
                {{ oracle.product_description(AllOneP) }}</p>
              </div>
            </div>
            <div class="table-box">
              <img alt="" v-if="AllOneP.product_cover != null" :src="AllOneP.product_cover"/>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import oracle from "@/oracle";

export default {
  name: "single",
  data: () => ({
    dataProducts: {id: "0", count: 10},
    page: 1,
    AllOneP: "",
    radios: "",
    id: "",
    IsTrue: false,
    Isfav: false,
    AllCat: [],
    store: [],
    oracle: oracle,
    isEN: oracle.isEN()
  }),
  methods: {
    SetFAv() {
      oracle.axios(
          "product/setFavorite", {product_id: this.id,}, (response) => {
            this.Isfav = response.data.record_favorite
          });
    },
    plusItem(item) {
      if (item.countStore >= item.quantity) {
        return;
      }
      if (oracle.getShop() != null && oracle.getShop() != item.shop.shop_id) {
        oracle.showMessage('در صورت تغییر فروشگاه، لیست محصولات انتخابی شما در سبد خرید پاک خواهد شد. ادامه میدهید؟',
            'بله فروشگاه را تغییر میدهم', () => {
              oracle.clearBasket();
              oracle.setShop(null);
              for (let i = 0; i < this.store.length; i++) {
                this.store[i].countStore = 0;
              }
              this.plusItem(item);
            })
        return;
      } else {
        oracle.setShop(item.shop.shop_id);
      }
      item.countStore++;
      oracle.addToBasket(this.id);
      this.$root.$emit("checkitem");
    },
    minusItem(item) {
      if (item.countStore == 0) {
        return;
      }
      item.countStore--;
      oracle.removeFromBasket(this.id);
      this.$root.$emit("checkitem");
    },
    getcategory(id, name) {
      this.$router.push({
        name: "products",
        query: {idcat: id, namecat: name},
      });
    },

    GetOneProduct(response) {
      this.AllOneP = response.data;
      this.Isfav = response.data.stat.record_favorite;
    },
    getProudoctAll(id) {
      oracle.axios(
          "product/getOne",
          {
            product_id: id,
          },
          this.GetOneProduct
      );
    },
    GetCat(response) {
      for (let i = 0; i < response.data.length; i++) {
        response.data[i].subcat = [];
      }
      this.AllCat = response.data;
      for (let i = 0; i < this.AllCat.length; i++) {
        oracle.axios(
            "productCategory/getList",
            {
              offset_by: 0,
              limit_by: 1000,
              order_by: "priority",
              parent_by: this.AllCat[i].category_id,
            },
            this.GetSubCat,
            null,
            null,
            this.AllCat[i]
        );
      }
    },
    GetSubCat(response, category) {
      category.subcat = response.data;
      this.IsTrue = true;
      this.IsTrue = false;
    },
    GetStore(response) {
      for (let i = 0; i < response.data.length; i++) {
        if (response.data[i].shop.shop_id == oracle.getShop()) {
          response.data[i].countStore = oracle.getCount(this.id);
        } else {
          response.data[i].countStore = 0;
        }
      }
      this.store = response.data;
    },
  },
  mounted() {
    oracle.axios(
        "productCategory/getList",
        {offset_by: 0, limit_by: 1000, order_by: "priority"},
        this.GetCat
    );
    if (this.$route.query.id) {
      this.id = this.$route.query.id;
      this.getProudoctAll(this.$route.query.id);
    }
    oracle.axios(
        "product/getQuantities",
        {product_id: this.$route.query.id},
        this.GetStore
    );
    this.$root.$on("checkitem_header", () => {
      if (this.$route.query.id != null) {
        oracle.axios(
            "product/getQuantities",
            {product_id: this.$route.query.id},
            this.GetStore
        );
      }
    });
  },
};
</script>
<style>
.single-product .swal2-popup {
  font-size: 11px !important;
}

.single-product .labelStyle .v-label {
  display: flex;
  justify-content: space-between;
}

.single-product {
  background: #fff;
}

.single-product .sub-categories {
  min-height: 450px;
  border: 2px solid #7ec352;
  border-radius: 3px;
}

.single-product .title-sub-categories {
  color: #fff;
  line-height: 40px;
  padding: 0 10px;
  font-size: 15px;
  background-color: #7ec352;
}

.single-product .sub-categories ul {
  display: flex;
  padding: 15px;
  font-size: 12px;
  margin: 0;
  flex-direction: column;
}

.single-product .item-sub-categories {
  padding-bottom: 10px;
}

.single-product .item-sub-categories span {
  font-size: 14px;
}

.single-product .item-sub-categories ul {
  padding-right: 15px;
  padding-left: 15px;
}

.single-product .item-sub-categories ul li {
  padding-right: 15px;
  padding-left: 15px;
  line-height: 30px;
  position: relative;
  transition: color ease 0.2s;
}

.single-product .item-sub-categories > ul li:before {
  content: "•";
  color: #7ec352;
  position: absolute;
  right: 0;
  font-size: 25px;
  line-height: 0;
  top: 16px;
}

.dir-ltr .single-product .item-sub-categories > ul li:before {
  content: "•";
  color: #7ec352;
  position: absolute;
  left: 0;
  font-size: 25px;
  line-height: 0;
  top: 16px;
}

.single-product .item-sub-categories ul li a {
  color: #333;
}

.single-product .inner-page-product {
  min-height: 240px !important;
}

.single-product .head-page-product {
  display: flex;
  position: relative;
  align-items: center;
}

.single-product .img-head-page-product {
  width: 140px;
  height: 140px;
  border-radius: 50%;
  overflow: hidden;
  margin-left: 20px;
  margin-right: 20px;
}

.single-product .img-head-page-product img {
  width: 100%;
  height: 100%;
}

.single-product .btn-likes {
  position: absolute;
  right: 5px;
  top: 5px;
}

.single-product .btn-likes i {
  font-size: 30px;
  color: #7dc353;
}

.single-product .name-product span {
  font-size: 16px;
  margin-top: 35px;
}

.single-product .text-page-product {
  display: flex;
  flex-direction: column;
}

.single-product .text-page-product span {
  font-size: 12px;
  margin-top: 20px;
  margin-right: 20px;
  margin-left: 20px;
  margin-bottom: 10px;
}

.single-product .item-category {
  color: #7ec352;
  font-size: 14px !important;
}

.single-product .add-basket button {
  color: #000000 !important;
  margin-top: 20px;
  font-size: 12px !important;
  /*width: 20%;*/
}

.single-product .add-basket ul {
  border-radius: 20px 0 20px 20px;
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 0;
  border: 2px solid #7ec352 !important;
  margin-top: 20px !important;
  background-color: #7dc353;
}

.single-product .add-basket .v-icon {
  color: white;
  font-size: 26px;
  padding: 0;
}

.single-product .table-box {
  width: 170px;
  height: 170px;
}

.single-product .table-box img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.single-product .inner-product {
  display: flex;
  justify-content: space-between;
}
</style>
